// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@pace/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { rfqMyQuotesTableStyles } from "@pace/Overrides/Widgets/RfqMyQuotes/RfqMyQuotesTable";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

rfqMyQuotesTableStyles.quoteNumberHeader = {
    tight: true,
};

rfqMyQuotesTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

rfqMyQuotesTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

rfqMyQuotesTableStyles.customerCell = {
    typographyProps: {
        ellipsis: true,
        css: css`
            display: block;
            max-width: 260px;
        `,
    },
};

rfqMyQuotesTableStyles.shipToCell = {
    typographyProps: {
        ellipsis: true,
        css: css`
            display: block;
            max-width: 260px;
        `,
    },
};

rfqMyQuotesTableStyles.dataCell = {
    css: css`
            word-break: break-word;
        ${xScreen("gt", "md")} {
            white-space: pre-wrap;
            min-width: 100px;
        }
    `,
};

rfqMyQuotesTableStyles.jobCell = {
    css: css`
        max-width: 180px;
    `,
    typographyProps: {
        css: css`
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
        `,
    },
};

rfqMyQuotesTableStyles.statusCell = {
    css: css`
        ${({ status }: any) => {
            if (status === "Expired") {
                return css`
                    color: ${color(`danger.main`)}
                `;
            }
            if (status === "Complete") {
                return css`
                    color: ${color(`success.main`)}
                `;
            }
            if (status === "Open") {
                return css`
                    color: ${color(`warning.main`)}
                `;
            }
        }}
    `,
};